module.exports = __webpack_public_path__ + "img/me.08bff99d.jpg";